<template>
  <div class="menuleft" :style="color">
    <div class="menu-backdrop" @click="menuClick()"></div>
    <div id="griBlockMenuLeft">

      <div class="menuleft-header" :style="color">

          <!--<img src="/static/img/logo-transparent.png" alt="Royal Pag" width="123px" class="logo-principal">-->

         <router-link to="/comprarCursos" >
        
         <div class="logo-principal" v-bind:style="{ backgroundImage: 'url(' + img + ')' }">  </div>
         
         <div id="imgLogo" v-bind:style="{ backgroundImage: icon['backgroundImage'], 
            backgroundColor: icon['backgroundColor'], width: icon['width'], backgroundSize: icon['backgroundSize'] }">
     
         </div>
                
         </router-link>
 
      </div>

      <div class="grid-content leftbar-content-parent">

        <div class="leftbar-content">
          <div class="menu-container app-menulist">
            <router-link to = "/comprarCursos" >
              <div class="item app-menulist" title="compraFichas">
                <i class="fa fa-book"  aria-hidden="true"></i>
                <span class=" app-menulist">Comprar Produtos</span>
              </div>
            </router-link>
          </div>
        </div>

        <div class="leftbar-content " v-for="m in getMenu" :key="m.id" >
          <div class="menu-container app-menulist" v-for="f in m.funcionalidades">
            <router-link :to="{ name: f.url }" v-tooltip="getOptionsTootip(f.descricao)" v-if="f.descricao!='Afiliados'">
              <div class="item app-menulist" :title="f.descricao" @click="menuClick()">
                <i :class="f.icone" class="app-menulist" aria-hidden="true">

                     <b-badge v-if="f.descricao == 'Transação' && unreadMessages.length > 0" variant="danger" class="rounded-circle " style="height: 30px;width: 30px;text-align: center; padding-top: 9px; font-size: 10px;vertical-align: -webkit-baseline-middle;position:absolute;display:inline;top:5px;margin:0px 0px 0px -14px">{{ unreadMessages.length }} </b-badge>
                     <b-badge v-if="f.descricao == 'Transações Arquivadas' && unreadMessagesArquivadas.length > 0" variant="danger" class="rounded-circle " style="height: 30px;width: 30px;text-align: center; padding-top: 9px; font-size: 10px;vertical-align: -webkit-baseline-middle;position:absolute;display:inline;top:5px;margin:0px 0px 0px -14px">{{ unreadMessagesArquivadas.length }} </b-badge>

                </i>
                <span class=" app-menulist">{{f.descricao}}</span>
              </div>
            </router-link>
          </div>
        </div>

        <div class="leftbar-content">
          <div class="menu-container app-menulist">
            <div class="bottom-flow" >
              <button v-tooltip="getOptionsTootip('Logout')" style="width: 100%;margin-left: 0;" @click.prevent="logout" class="btn line white signout">
                <i class="fas fa-door-closed"></i>
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>



      </div>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import localforage from 'localforage'
  import site_style from '@/service/site_style'

  export default {
    data () {
      return {
        img: site_style.getLogoMenu().homeLogo,  
        icon: site_style.getLogo().icon,  
        color: site_style.getColorMenu(), 
        countNoReadMessage: 0,
        countMsg: 0,
        isCountNoReadMessage: 0,
        isChatToogleOpen: false,
        unreadMessages:  [],
        unreadMessagesArquivadas: []
      }
    },
    computed: {
      ...mapGetters(['usuarioLogado', 'getMenu']),
      $collapseItems () {        
        return this.$children.filter(child => child._isCollapseItem)
      },
      isChrome () {
        return !!window.chrome
      },
      isAdministrador () {
        if (this.usuarioLogado) {
          return this.usuarioLogado.role === 'admin'
        }
      }
    },
    methods: {
      ...mapActions(['removeToken']),
      getOptionsTootip (content) {
        if (window.matchMedia("(min-width: 768px)").matches) {
          let optinsTooltip = {}
          optinsTooltip.content = content
          optinsTooltip.placement = 'left-center'
          optinsTooltip.classes = ['info', 'menu-tooltip']
          optinsTooltip.targetClasses = ['it-has-a-tooltip']
          optinsTooltip.offset = 100
          optinsTooltip.delay = {}
          optinsTooltip.delay.show = 100
          optinsTooltip.delay.hide = 100
          return optinsTooltip
        }
      },
      logout () {
        localforage.removeItem('token').then(() => {
          this.removeToken()
          this.$router.push({ name: 'auth.index' })
        })
      },
      openByIndex (index) {
        this.$collapseItems.forEach((item, i) => {
          if (i !== index) {
            item.isActived = false
          }
        })
      },
      menuClick() {
        $('#menu-container').addClass('closed')
        $('#menu-container').removeClass('opened')
      },
      setCountNoReadMessage (value) {
        if (value !== 0) {
          this.isCountNoReadMessage++
        } else {
          this.isCountNoReadMessage = 0
        }
        this.$emit('count-chat', this.isCountNoReadMessage)
        if (this.isChatToogleOpen) {
          this.isCountNoReadMessage = 0
        }
        this.countMsg = this.isCountNoReadMessage
      },
      refreshChatCount(message) {
      
         if(this.isAdministrador && message.usuario.idTipoUsuario  === 1) {

            this.$bus.$emit('updateChatCount', message.idTransacaoCompraVenda)
         }
      },
    },
    async mounted () {

      this.unreadMessages = await localforage.getItem('unreadMessages') || []
      this.unreadMessagesArquivadas = await localforage.getItem('unreadMessagesArquivadas') || []

      this.$on('closeall', (index) => {
        this.openByIndex(index)
      }),
      this.$bus.$on('newMessageToChatList', message => {
 
        if(message) {
          if(message.idTransacaoCompraVenda) {

                console.log('transacaoStatus: ' + message.transacaoStatus)

                if(message.transacaoStatus == 'APROVADO'){
 
                   if(!this.unreadMessagesArquivadas.includes(message.idTransacaoCompraVenda.toString())){
                       this.unreadMessagesArquivadas.push(message.idTransacaoCompraVenda.toString())
                   }

                   localforage.setItem('unreadMessagesArquivadas', this.unreadMessagesArquivadas)

                } else{

                   if(!this.unreadMessages.includes(message.idTransacaoCompraVenda.toString())){
                       this.unreadMessages.push(message.idTransacaoCompraVenda.toString())
                   }
                   
                   localforage.setItem('unreadMessages', this.unreadMessages)

                }

                this.refreshChatCount(message)
    
              }
            }
 
      }),
        this.$bus.$on('updateChatCount', message => {

        if(this.unreadMessages.includes(message.toString())){
          this.unreadMessages.splice(this.unreadMessages.indexOf(message.toString()), 1);
          localforage.setItem('unreadMessages', this.unreadMessages)
        }
        else if(this.unreadMessagesArquivadas.includes(message.toString())){
          this.unreadMessagesArquivadas.splice(this.unreadMessagesArquivadas.indexOf(message.toString()), 1);
          localforage.setItem('unreadMessagesArquivadas', this.unreadMessagesArquivadas)
        }
 
      })
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  @import '../../assets/css/menuleft.css';



  .transaction-message-badge {

     position: absolute;
     height: 30px;
     width: 30px;
     text-align: center;
     font-size: 10px;
     right: 68px;
     top: 4px;

   }

  .menu-closed #imgLogo {
    display: block;
    background-image: url("/static/img/icon-crown.png");
  //  background-color: #fff;
    border-radius: 4px;
    padding: 10px 13px 11px 13px;
    height: 39px;
    margin: 9px auto;
    background-size: 30px 18px;
    background-position: center;
    background-repeat: no-repeat;
  }
 
  .no-effect-link {
    display: flex;
    justify-content: center;
  }

  #griBlockMenuLeft {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;

    @media screen and (min-width: 576px) {
      width: 210px;
    }

    @media screen and (min-width: 768px) {
      width: 210px;
    }

    &.menu-closed {
      width: 80px;
    }
  }

  .menu-closed.closed:not(#admin-wrapper) #griBlockMenuLeft {
    width: 80px;
  }

  .menuleft {
 
    height: 100%;
  }

  .menuleft .menuleft-header {
    padding: 8px 5px 5px 5px;
  }

  .menuleft .menuleft-header .content-logo-coroa .logo-coroa {
    display: none;

    @media screen and (min-width: 576px) {
      display: block;
    }

    @media screen and (min-width: 768px) {
      display: none;
    }
  }

  .menu-closed .menuleft .menuleft-header .content-logo-coroa .logo-coroa {
    display: block;
  }

  .menuleft .menuleft-header .logo-principal {
    display: block;

    //@at-rootbackground-image: url("/static/img/logo-transparent.png");
    height: 55px;
    width: 100%;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .menu-closed:not(.opened) .menuleft .menuleft-header .logo-principal {
    display: none;
  }

  .menu-closed.opened .menuleft .menuleft-header .logo-principal {
    display: block;
  }

  .leftbar-content-parent {
    height: calc(100% - 70px);
    width: 100%;
  }

  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist {
    text-align: center;
    border-top: 1px solid #e8e6e6;
    width: 100%;
  }

  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist span {
    margin-top: 5px;
    display: block;
    font-size: 1.0115rem;
    font-weight: bold;
    margin-left: 10px;

    @media screen and (min-width: 576px) {
      margin-left: 0px;
      display: block;
    }
  }

  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist i {
    font-size: 1.726rem;
  }

  .menu-closed.closed:not(#admin-wrapper) .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist span {
    display: none;
  }

  .menuleft .bottom-flow button.btn span {
    font-size: 1.0115rem;
    margin-top: 5px;
    display: block;
    font-weight: bold;
    margin-left: 10px;

    @media screen and (min-width: 576px) {
      display: block;
      margin-left: 0px;
    }
  }

  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist:hover {
    background: none;
  }
  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist.active {
    color: rgb(49, 75, 136);
    background-color: #eeeeee;
  }
  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist:hover {

    @media screen and (min-width: 576px) {
      color: #f6b428;
    }

  }
  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist {
    padding: 16px 0;
    color: #fff;

    display: flex;
    margin-left: 20px;
  }

  @media screen and (min-width: 576px) {
    .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist {
      display: block;
      margin-left: 0px;
    }
  }

  @media screen and (max-width: 576px) {
    .left-side:not(.closed) .menu-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);

    }
  }








  div.menu-container {
    position: relative;
    padding: 0;
    color: rgba(0,0,0, .70);
    /* border-bottom: 1px solid rgba(249,249,249,0.1); */
    cursor: pointer;
  }





  .menuleft .showSpan .leftbar-content-parent .leftbar-content span {
    display: block;
  }























  .fixo-close {
    width: 80px !important;
    overflow: hidden !important;
  }
  .rolavel-close {
    width: 90px !important;
    overflow-y: scroll !important;
  }

  :host {
    width: 100%;
    height: 100%;
    font-weight: normal;
  }
  .user-container {
    width: 100%;
    height: 100%;
  }
  .avatar-container {
    width: 60px;
    height: 100%;
    float: left;
  }
  .avatar {
    width: 90%;
    height: 90%;
    margin: 3px auto;
    overflow: hidden;
  }
  .avatar img {
    width: 90px;
  }
  .menu-actions-section {
    margin-left: 60px; /* this hold with .avatar-container width */
    height: 100%;
    background: red;
    line-height: 50px;
  }
  .minibox {
    float: left;
    position: relative;
  }
  .minibox.username {
    overflow: hidden;
    padding-left: 4px;
    /* min-width: 100px; */
    width: 70%;
    height: 100%;
    background: aquamarine;
  }

  div.menu-container.dark {
    color: rgba(255,255,255,.70);
  }
  div.menu-container:hover {
    background: rgba(0,0,0,0.1);
  }
  div.menu-container .highlight {
    display: block;
    float: left;
    height: 45px;
    width: 8px;
  }
  div.menu-container:hover .highlight {
    background: white;
  }
  div.menu-container .item {
    font-size: 0.85em;
  }

  div.menu-container.dark {
    color: rgba(255,255,255,.70);
  }
  div.menu-container:hover {
    background: rgba(0,0,0,0.1);
  }
  div.menu-container .highlight {
    display: block;
    float: left;
    height: 45px;
    width: 8px;
  }
  div.menu-container:hover .highlight {
    background: white;
  }

  div.item {
    display: block;
  }

  .links {
    font-weight: normal;
  }


  .links {
    font-weight: normal;
  }

  .minibox.menu {
    text-align: center;
    height: 100%;
    background: blue;
    cursor: pointer;
    width: 30%;
  }
  .action-sheet {
    position: absolute;
    top: 50px;
    left: 0;
  }
  .macula {
    position: absolute;
    float: left;
    background: white;
    height: 0px;
    opacity: 0;
    width: 90%;
    bottom: 75px;
    right: 6px;
    -webkit-box-shadow: 0px 0px 6px 0px rgba(204,204,204,1);
    -moz-box-shadow: 0px 0px 6px 0px rgba(204,204,204,1);
    box-shadow: 0px 0px 6px 0px rgba(204,204,204,1);
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
  }
  .macula.active {
    height: 200px;
    opacity: 1;
  }
  .macula::after  {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    bottom: -18px;
    right: 7%;
    box-sizing: border-box;
    border: 10px solid red;
    border-color: transparent transparent #FFF #FFF;
    transform-origin: 0 0;
    transform: rotate(-45deg);
    box-shadow: -3px 3px 3px 0 rgba(204,204,204,1);
    display: none;
  }
  .macula::before {
    /* fallback css3 into after */
    content: '';
    position: absolute;
    right: 5%;
    bottom: -10px;
    display: block;
    width: 0px;
    height: 0px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid white;
    display: none;
  }

  .two {
    display: table-cell;
    overflow: hidden;
    background: white;
    height: 100%;
    width: 100%;
    vertical-align: top;
    /* debug */
  }


  .leftbar-bottom-parent {
    position: absolute;
    height: 70px;
    bottom: 0;
    width: 100%;
  }

  /* fallback for zf */
  .content-header-parent {
    position: relative;
    width: 100%;
    height: 60px;
    background: #F9F9F9;
    z-index: 999;
    box-shadow: 0px 4px 0px #EEE;
    -moz-box-shadow: 0px 4px 0px #EEE;
    -webkit-box-shadow: 0px 4px 0px #EEE;
  }
  .content-header-parent .button-icon {
    margin-top: 10px;
    margin-left: 6px;
  }
  .content-header-parent > div.column {
    position: absolute;
    height: 100%;
  }
  .content-header-parent input.underline {
    background: #F9F9F9;
  }
  .content-content {
    position: relative;
    display: block;
    height: 100vh;
    z-index: 888;
    width: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .content-content .grid-content {
    padding-bottom: 60px; /* workaround for footer menu bar from devices */
  }
  .left-content-parent {
    position: relative;
    display: block;
    margin: 0 auto;
    /* background: red;
    padding: 2px;
    height: 100% */
    width: 100%;
  }
  .left-content-parent .grid-content {
    margin-bottom: 60px; /* this required due 60px from header */
    overflow: hidden;
  }
  .rightbar-content-parent {
    position: relative;
    background: white;
    height: 100%;
    display: none;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    border-left: 1px solid #EEE;
  }

  /************************************
  * leftbar is now for all pages into
  * dashboard based. This section was
  * created to grouped that properties.
  *************************************/

  .leftbar-content h4 {
    padding-left: 15px; /* hold with padding-left of item from app-menulist */
    color: aliceblue;
  }
  .username {
    position: relative;
    top: 9px;
    opacity: 0.7;
    color: white;
    margin-top: 4px;
    font-size: 0.85em;
  }
  .left-margin {
    padding-left: 15px;
  }
  .leftbar-content h4 {
    border-top: 1px solid rgba(255,255,255,0.1);
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: normal;
    margin-bottom: 10px;
  }
  .leftbar-content h4 small {
    font-size: 0.85em;
    font-weight: 300;
    opacity: 0.7;
    color: white;
  }
  /* atividades recents */
  .leftbar-content .recents {
    color: rgba(255,255,255,0.54);
    font-size: 1.05em;
    line-height: 1.25em;
  }
  .leftbar-content .recents ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    padding-left: 15px;
  }
  .leftbar-content .recents ul li div.r-scope {
    padding: 6px;
    -webkit-border-top-left-radius: 4px;
    -webkit-border-bottom-left-radius: 4px;
    -moz-border-radius-topleft: 4px;
    -moz-border-radius-bottomleft: 4px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .leftbar-content .recents ul li div.r-scope:hover {
    cursor: pointer;
    background: rgba(0,0,0,0.1);
  }
  .leftbar-content .r-header {
    font-weight: 400;
  }
  .leftbar-content .r-description {
    font-size: 0.85em;
  }
  .leftbar-content .r-highlight {
    font-size: 0.95em;
    font-weight: 400;
    color: rgba(246, 180, 40, 1) !important;
  }
  .leftbar-content .r-highlight a {
    color: rgba(246, 180, 40, 1);
    font-weight: bold;
  }
  .leftbar-content .r-highlight a:hover {
    border-bottom: 1px rgba(246, 180, 40, 1) dotted;
  }
  .leftbar-content .r-line {
    border-top: 1px solid rgba(255,255,255,0.1);
    margin-top: 10px;
    height: 8px;
  }

  .leftbar-content .footers-links {
    margin-top: 24px;
    padding-left: 14px;
    padding-right: 14px;
  }
  .leftbar-content .footers-links a {
    font-size: 10px;
    color: rgba(255,255,255,.7);
    line-height: 12px;
    font-weight: normal;
  }
  .leftbar-content .footers-links a:after {
    content: "|";
    margin-left: 4px;
    margin-right: 4px;
  }
  .leftbar-content .footers-links a:last-child:after {
    content: "";
  }
  .logo-link {
    color: white;
  }
  button.btn.signout {
    background: none;
    border-color: rgba(255,255,255,0.12);
  }
  button.btn.signout:hover {
    background: rgba(0,0,0,0.12);
  }
  .toggle-menu {
    display: none;
  }
  .titles {
    /* margin-top: 10px; */
    display: inline-block;
  }
  .titles .title, .titles .subtitle {
    display: inline-block;
    margin-top: 20px;
    /* margin-left: 12px; */
    margin-left: 80px;
  }
  .title {
    font-weight: 700;
  }
  .subtitle {
    font-weight: 300;
  }
  #taxinfo {
    opacity: 0;
    -webkit-transition: opacity 0.3s ease;
    -moz-transition: opacity 0.3s ease;
    -o-transition: opacity 0.3s ease;
    -ms-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
  }
  #taxinfo.active {
    opacity: 1;
  }
  a.no-effect-link, a.no-effect-link:link, a.no-effect-link:visited,
  a.no-effect-link:hover, a.no-effect-link:active  {
    border: none;
  }
  .fix-space {
    position: fixed;
    text-align: right;
    top: 0;
    right: 0;
    display: table;
    font-size: 26px;
    background-color: #F9F9F9;
    color: rgba(0,0,0,0.54);
    height: 60px;
    box-sizing: border-box;
  }
  .notifications {
    position: fixed;
    right: -320px;
    top: 0;
    text-align: right;
    width: 300px;
    background: white;
    height: 100vh;
    overflow: hidden;
    transition: right 300ms ease;
    -moz-transition: right 300ms ease;
    -webkit-transition: right 300ms ease;
    -o-transition: right 300ms ease;
  }
  .notifications.opened {
    right: 0;
    -webkit-box-shadow: 0px 3px 8px 2px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 3px 8px 2px rgba(0,0,0,0.2);
    box-shadow: 0px 3px 8px 2px rgba(0,0,0,0.2);
  }
  .notifications .notify-items {
    color: rgba(0,0,0,0.86);
    text-align: left;
    font-size: 12px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    /* position: relative; */
    height: 100%;
  }
  .notifications h5 {
    margin: 0;
    font-weight: bold;
    font-size: 14px;
    font-weight: 600;
    text-align: left;
    padding-left: 12px;
  }
  .notifications .notify-items .notify-item {
    padding-left: 20px;
    padding-top: 18px;
    padding-bottom: 16px;
    max-height: 64px;
    overflow: hidden;
    border-bottom: 1px solid rgba(0,0,0,0.12);
    cursor: pointer;
    font-weight: normal;
    color: rgba(0,0,0,0.70);
  }
  .notifications .notify-items .notify-item:hover {
    background-color:aliceblue;
  }
  .notifications .notify-items .notify-item .author {
    font-weight: bold;
  }
  .notifications .notify-items .notify-item .datetime {
    color: rgba(0,0,0,0.54);
    font-weight: normal;
  }
  .notifications .space {
    position: relative;
    display: table;
    width: 100%;
    font-size: 26px;
    background-color: #F9F9F9;
    color: rgba(0,0,0,0.54);
    height: 60px;
    box-sizing: border-box;
  }
  .notifications .space .cells, .fix-space .cells {
    display: table-cell;
    vertical-align: middle;
    text-align: right;
  }
  .notifications .space .messages-counter, .fix-space .messages-counter  {
    font-size: 12px;
    top: -40px;
    position: relative;
    text-align: center;
    background-color: #F73859;
    color: white;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    line-height: 16px;
    left: 5px;
    display: inline-block;
  }
  .notifications .space .notify-info, .fix-space .notify-info {
    position: absolute;
    display: inline;
    margin-top: 15px;
    top: 0;
    right: 13px;
    cursor: pointer;
  }
  .notifications .space .cells .cell-one {
    width: 45%;
  }
  .notifications .space .cells .cell-two {
    width: 45%;
    text-align: left;
  }
  .useridhash {
    cursor: pointer;
    opacity: 0 !important;
    transition: opacity 1s ease-in-out;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -ms-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
  }
  .useridhash.active {
    opacity: 0.54 !important;
  }
  #can_search {
    position: absolute;
    display: none;
    bottom: 0;
  }
  #can_search label {
    position: absolute;
    right: 45px;
    top: 8px;
    cursor: pointer;
  }
  .labelShowSearch {
    position: absolute;
    right: 45px;
    top: 25%;
    margin-top: 8px;
  }
  #megaloading {
    position: fixed;
    z-index: 1100;
    width: 100%;
    height: 100%; /* fallback vh */
    height: 100vh;
    background-color: rgba(255,255,255,0.80);
    text-align: center;
    display: none;
  }
  #megaloading div {
    display: table;
    height: 100%;
    width: 100%;
  }
  #megaloading div div {
    display: table-cell;
    vertical-align: middle;
    height: 100%;
    width: 100%;
  }

  /* paymee styling */
  ul.paymee_steps {
    list-style: none !important;
    padding: 0;
  }
  ul.paymee_steps li {
    line-height: 1.5rem;
  }
  ul.paymee_steps li a {
    color:inherit;
    text-decoration:none;
  }
  ul.stores_providers {
    list-style: none !important;
    margin-top: 21px;
    padding: 0;
  }
  ul.stores_providers li {
    display: inline;
  }
  ul.stores_providers li.stores {
    padding-right: 13px;
  }
  ul.stores_providers li.stores_blank {

  }
  ul.stores_providers li.stores > a,
  ul.stores_providers li.stores > a:visited,
  ul.stores_providers li.stores > a:hover,
  ul.stores_providers li.stores > a:active {
    text-decoration: none !important;
  }
  ul.shortcuts {
    list-style: none;
    list-style-type: none !important;
  }
  ul.shortcuts li {
    color: #424242;
    line-height: 1.30em;
    border-bottom: 1px solid #EEE;
    padding-top: 3px;
    min-height: 3em;
    margin-top: 3px;
    margin-bottom: 3px;
  }
  /* END TO LEFT BAR SCOPE */
  @media screen and (max-width: 690px) {


    .toggle-menu {
      display: block;
    }
    .content-header-parent {
      color: rgba(255,255,255,0.86);
      background-color: rgba(34, 77, 133, 1);
    }
    .content-header-parent input.underline {
      background-color: rgba(34, 77, 133, 1);
      color: rgba(255,255,255,1);
    }
    .notifications .space, .fix-space {
      background-color: rgba(34, 77, 133, 1);
      color: white;
    }
  }

  @media screen and (min-width: 700px) {



    .two {

    }
    .rightbar-content-parent {
      display: none;
    }
    .left-content-parent {
      /* display: inline-block; */
    }
  }
  @media screen and (min-width: 900px) {
    .left-content-parent {
      /* display: inline-block; */
      /* max-width: 70%; */
      max-width: 800px;
    }
    .rightbar-content-parent {
      display: inline-block;
      width: 25%;
    }
  }
  .macula.active::after, .macula.active::before {
    display: block;
  }

  /* toggle menu - onoffswitch
�-----------------------���������� */
  .onoffswitch {
    position: relative;
    width: 55px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  .onoffswitch-checkbox {
    display: none;
  }
  .onoffswitch-label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    height: 18px; /* ID: 234 */
    padding: 0;
    line-height: 18px; /* ID: 234 */
    border: 0px solid #FFFFFF;
    border-radius: 30px;
    background-color: #9E9E9E;
  }
  .onoffswitch-label:before {
    content: "";
    display: block;
    width: 28px; /* ID: 234 */
    margin: -5px;
    background: #FFFFFF;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 34px;
    border-radius: 30px;
    box-shadow: 0 6px 12px 0px #757575;
  }
  .onoffswitch-checkbox:checked + .onoffswitch-label {
    background-color: rgba(33, 150, 243, 0.90);
  }
  .onoffswitch-checkbox:checked + .onoffswitch-label, .onoffswitch-checkbox:checked + .onoffswitch-label:before {
    border-color: rgba(33, 150, 243, 1);;
  }
  .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
  }
  .onoffswitch-checkbox:checked + .onoffswitch-label:before {
    right: 0px;
    background-color: rgba(33, 150, 243, 1);
    box-shadow: 3px 6px 18px 0px rgba(0,0,0,0.2);
  }
  .legend {
    display: table;
  }
  .legend div {
    display: table-cell;
  }
  .grid-content { overflow-y: auto; }



  .menuleft .collapse.showSpan {
    min-width: 210px;
  }
  .menuleft .collapse {
    /* width: 80px; */
    min-width: 80px;
  }

  .menuleft-header img {
    display: block;
    margin: 0 auto;
  }
  .menuleft-header .content-logo-coroa .logo-coroa {
    margin-top: 9px;
    margin-left: 6px;
    height: 48px;
  }
  .menuleft-header .content-logo-coroa .logo-coroa {
    background-color: #fff;
    border-radius: 4px;
    padding: 10px 13px 11px 13px;
    height: 39px;
    margin: 9px auto;
  }


  .menuleft .leftbar-content-parent {
    text-align: center;
  }

  .menuleft .leftbar-content-parent .page-ds-user-profile {
    position: relative;
    display: inline-block;
    overflow: hidden;
    margin: 20px 0;
  }

  .menuleft .leftbar-content-parent .page-ds-user-profile .username {
    color: rgb(33, 150, 243);
  }

  .menuleft .leftbar-content-parent .page-ds-user-profile #photo {
    width: 100%;
  }











  .labelshowHideLeftBar {
    position: absolute;
    top: 25%;
    /* margin-top: 8px; */
    margin-left: 32px;
    font-size: 1.55em;
    cursor: pointer;
    z-index: 99999;
  }

  .labelshowHideLeftBar i {
    color: #333;
  }

  .labelshowHideLeftBar a:hover {
    text-decoration: none;
    border-bottom: none;
    opacity: 0.7;
  }

  .menuleft .titles {
    margin-left: 19px !important;
  }


  /** titles **/
  .menuleft .titles .button-icon { display: none; }

  /** logout **/
  .menuleft .bottom-flow {
    padding: 13px 0;
    margin-left: 13px;
    text-align: left;

    @media screen and (min-width: 576px) {
      text-align: center;
      margin-left: 0px;
    }
  }
  .menuleft .bottom-flow:hover {
    @media screen and (min-width: 576px) {
      color: #f6b428;
      cursor: pointer;
    }
  }
  .menuleft .bottom-flow button.btn {
    color: #fff;
    border: none;
    /* border: 1px solid transparent; */
    border-color: transparent;
    background: none !important;

    display: flex;

    @media screen and (min-width: 576px) {
      display: inline-block;
    }
  }
  .menuleft .bottom-flow:hover button.btn {
    @media screen and (min-width: 576px) {
      color: #f6b428;
    }
  }

  .menuleft .bottom-flow button.btn,
  .menuleft .bottom-flow button.btn:hover  {
    /* border: 1px solid rgba(255,255,255,0.70);
    border-color: rgba(255,255,255,0.12); */
    border: none !important;
    border-color: transparent !important;
    background: none !important;
  }

  /** Media queries **/
  @media screen and (max-width: 690px) {

    .labelshowHideLeftBar {
      top: 30%;
      /* margin-left: 72px; */
    }


    .labelshowHideLeftBar i {
      color: #fff !important;
    }


    .menuleft .leftbar-content-parent .leftbar-content.showSpan span {
      display: none !important;
    }

    .menuleft .menuleft-headerheader .logo-crown {
      display: block !important;
    }

    .menuleft .showSpan .bottom-flow button.btn span {
      display: none;
    }
  }

  .menuleft .bottom-flow button.btn i {
    font-size: 1.609rem;
  }

  @media screen and (min-width: 576px) {
    .menu-closed .menuleft .bottom-flow button.btn span {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// the-menu.vue?3e758af6